import {btoa} from 'abab'
import {Suspense} from 'react'
import {
  graphql,
  useLazyLoadQuery,
  usePaginationFragment,
} from 'react-relay/hooks'
import {useParams} from 'react-router-dom'
import {Grid} from '@chakra-ui/react'

import {UserProfileFansQuery} from './__generated__/UserProfileFansQuery.graphql'
import {UserProfileFans_user_followers$key} from './__generated__/UserProfileFans_user_followers.graphql'
import {UserProfileFansPaginationQuery} from './__generated__/UserProfileFansPaginationQuery.graphql'

import {UserProfileFansSkeleton} from './UserProfileFansSkeleton'
import {UserCard} from '../components/UserCard'
import {MorePager} from 'components/MorePager'

const NUMBER_OF_USERS_PER_PAGE = 9

export function UserProfileFansSuspense() {
  return (
    <Suspense fallback={<UserProfileFansSkeleton />}>
      <UserProfileFans />
    </Suspense>
  )
}

export function UserProfileFans() {
  const {userId} = useParams()
  const {user} = useLazyLoadQuery<UserProfileFansQuery>(
    graphql`
      query UserProfileFansQuery($count: Int!, $userId: ID!) {
        user(id: $userId) {
          ...UserProfileFans_user_followers @arguments(count: $count)
        }
      }
    `,
    {
      count: NUMBER_OF_USERS_PER_PAGE,
      userId: btoa(`User:${userId}`),
    }
  )
  const {data, hasNext, isLoadingNext, loadNext} = usePaginationFragment<
    UserProfileFansPaginationQuery,
    UserProfileFans_user_followers$key
  >(
    graphql`
      fragment UserProfileFans_user_followers on User
      @argumentDefinitions(count: {type: "Int!"}, cursor: {type: "String"})
      @refetchable(queryName: "UserProfileFansPaginationQuery") {
        followers(after: $cursor, first: $count)
          @connection(key: "UserProfileFans_user_followers") {
          edges {
            node {
              ...UserCard_user
              id
            }
          }
        }
      }
    `,
    user
  )

  return (
    <>
      <Grid gap={4} templateColumns="repeat(3, 1fr)">
        {data.followers.edges.map((edge) => (
          <UserCard key={edge.node.id} user={edge.node} />
        ))}
      </Grid>

      {hasNext && (
        <MorePager
          mt={4}
          onMore={() => {
            if (!isLoadingNext) {
              loadNext(NUMBER_OF_USERS_PER_PAGE)
            }
          }}
        >
          <UserProfileFansSkeleton />
        </MorePager>
      )}
    </>
  )
}
